import { render, staticRenderFns } from "./PortalView.vue?vue&type=template&id=7b79e2e0&scoped=true"
import script from "./PortalView.vue?vue&type=script&lang=js"
export * from "./PortalView.vue?vue&type=script&lang=js"
import style0 from "./PortalView.vue?vue&type=style&index=0&id=7b79e2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b79e2e0",
  null
  
)

export default component.exports